<template>
    <a-dropdown :trigger="['click']" placement="bottomRight">
        <a-avatar size="small" style="background-color: #87d068; cursor: pointer;">
            <template #icon><UserOutlined /></template>
        </a-avatar>
        <template #overlay>
            <a-menu>
                <a-menu-item @click="showProfileModal">
                    <UserOutlined /> 个人信息
                </a-menu-item>
                <a-menu-divider />
                <a-menu-item @click="handleLogout">
                    <LogoutOutlined /> 退出登录
                </a-menu-item>
            </a-menu>
        </template>
    </a-dropdown>

    <!-- 个人信息弹窗 -->
    <a-modal
        v-model:visible="profileVisible"
        title="个人信息"
        :confirm-loading="saving"
        width="520px"
        @ok="handleSave"
        @cancel="cancelEdit"
    >
        <a-spin :spinning="loading">
            <a-form
                ref="formRef"
                :model="formData"
                :label-col="{ span: 4 }"
                :wrapper-col="{ span: 20 }"
            >
                <a-form-item label="用户名" name="username">
                    <a-input v-model:value="formData.username" placeholder="用户名" />
                </a-form-item>
                <a-form-item label="手机号" name="phoneNumber">
                    <a-input v-model:value="formData.phoneNumber" placeholder="手机号" />
                </a-form-item>
                <a-form-item label="邮箱" name="email">
                    <a-input v-model:value="formData.email" placeholder="邮箱" />
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>
import { ref, reactive } from 'vue';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { getInfoBytoken, updateUsByToken } from '@/api/service';
import { useRouter } from 'vue-router';

export default {
    name: 'BizUserProfile',
    components: {
        UserOutlined,
        LogoutOutlined,
    },
    setup() {
        const router = useRouter();
        const profileVisible = ref(false);
        const loading = ref(false);
        const saving = ref(false);
        const formRef = ref(null);

        const formData = reactive({
            id: '',
            username: '',
            phoneNumber: '',
            email: '',
        });

        let originalData = null;

        const fetchUserInfo = async () => {
            loading.value = true;
            try {
                const response = await getInfoBytoken();
                if (response.code === 200 && response.data) {
                    const user = response.data;
                    formData.id = user.id || '';
                    formData.username = user.username || user.userName || '';
                    formData.phoneNumber = user.phoneNumber || user.phonenumber || user.phone || '';
                    formData.email = user.email || '';
                    // 保存原始数据用于取消时恢复
                    originalData = { ...formData };
                }
            } catch (e) {
                console.error('获取用户信息失败', e);
            }
            loading.value = false;
        };

        const showProfileModal = () => {
            fetchUserInfo();
            profileVisible.value = true;
        };

        const cancelEdit = () => {
            if (originalData) {
                Object.assign(formData, originalData);
            }
        };

        const handleSave = async () => {
            saving.value = true;
            try {
                const response = await updateUsByToken({
                    id: formData.id,
                    username: formData.username,
                    phoneNumber: formData.phoneNumber,
                    email: formData.email,
                });
                if (response.code === 200) {
                    message.success('保存成功');
                    profileVisible.value = false;
                    originalData = { ...formData };
                } else {
                    message.error(response.msg || '保存失败');
                }
            } catch (e) {
                message.error('保存失败');
            }
            saving.value = false;
        };

        const handleLogout = () => {
            window.localStorage.clear();
            message.success('已退出登录');
            router.push('/login');
        };

        return {
            profileVisible,
            loading,
            saving,
            formRef,
            formData,
            showProfileModal,
            cancelEdit,
            handleSave,
            handleLogout,
        };
    },
};
</script>
